import { render, staticRenderFns } from "./1-TeamDetails.vue?vue&type=template&id=d6cfff98&scoped=true"
import script from "./1-TeamDetails.vue?vue&type=script&lang=js"
export * from "./1-TeamDetails.vue?vue&type=script&lang=js"
import style0 from "./1-TeamDetails.vue?vue&type=style&index=0&id=d6cfff98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cfff98",
  null
  
)

export default component.exports